<template>
  <v-bottom-navigation
    v-model="bottomNav">

    <router-link to="/" tag="button">
      <v-btn value="/">
        <span>Home</span>
        <v-icon>mdi-home</v-icon>
      </v-btn>
    </router-link>

    <router-link to="/drives" tag="button">
      <v-btn value="/drives">
        <span>Drives</span>
        <v-icon>mdi-cloud-search</v-icon>
      </v-btn>
    </router-link>

    <router-link to="/rule_groups" tag="button">
      <v-btn value="/rule_groups">
        <span>Regras</span>
        <v-icon>mdi-security</v-icon>
      </v-btn>
    </router-link>

  </v-bottom-navigation>
</template>

<script>
export default {
  data: () => ({
    bottomNav: '/',
  }),
  beforeMount() {
    this.bottomNav = this.$route.path;
  },
};
</script>
